import React from 'react';
import { useDispatch } from 'react-redux';
import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import useTitle from 'hooks/useTitle';
import PageContainer from 'pages/bridge/styled/PageContainer';
import ToolReRollCard from "./ToolReRollCard";

interface IProps {}

const BankPage: React.FunctionComponent<IProps> = () => {
  useTitle({ title: 'Bank' });
  const dispatch = useDispatch();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <PageContainer>
      <Grid
        container
        spacing={2}
        sx={{
          justifyContent: 'center',
          alignItems: 'stretch',
          display: 'flex',
          marginTop: 0,
          marginBottom: 3,
          width: matches ? 0.8 : 1,
        }}
      >
        <Grid item xs={12}>
          <Typography variant="h4" sx={{ textAlign: 'center' }}>
            Cosmic Fixer
          </Typography>
        </Grid>
        <Grid item xs={12} md={6} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <ToolReRollCard />
        </Grid>

      </Grid>
    </PageContainer>
  );
};

export default BankPage;
